// SendToViewer will forward the viewer to the viewing page
// at the point where the streat is active and the user has a ticket.
export class SendToViewer extends HTMLElement {
	constructor() {
		super();
		this.has_ticket = false;
		document.addEventListener(`veedo-ticket`, evt=>{
			this.has_ticket = evt.detail;
			this.check();
		});
		this.stream_state = false;
		document.addEventListener(`veedo-stream-state`,  evt=>{
			console.log(`SendToViewer: stream_state evt.detail=`, evt.detail);
			this.stream_state = (`STREAM_FILE_PRESENT`==evt.detail);
			this.check();
		});
		this.proxy = false;
		document.addEventListener(`veedo-proxy`, evt=>{
			this.proxy = evt.detail;
			console.log(`SendToViewer : got proxy ${this.proxy}`);
			this.check();
		});
		this.countdown_complete = false;
		document.addEventListener(`veedo-countdown-complete`, evt=>{
			this.countdown_complete = true;
			this.check();
		});
	}
	check() {
		if (this.countdown_complete) {
			console.log(`Countdown is complete`);
			if (this.has_ticket && this.stream_state && this.proxy) {
				console.log(`User has a ticket AND stream started AND proxy`);
				// get our current query parameters which could contain name
				const queryParams = new URLSearchParams(window.location.search);
				if (queryParams.get("name")){
					queryParams.delete(`reload`);
					queryParams.set(`reload`, `true`); // we need 'reload' to attempt a login
				}
				queryParams.delete(`from`);
				queryParams.set(`from`, encodeURIComponent(document.location.host));
				var loc = `//${this.proxy}?${queryParams.toString()}`;
				console.log(`And we've got a proxy - forwarding to ${loc}`);
				document.location = loc;
			} else {
				// waiting for ticket message or stream state
			}
		} else {
			// countdown still showing
		}
	}
}
customElements.define(`veedo-send-to-viewer`, SendToViewer);